'use client'

import { useEffect } from 'react'

type UrlCorrectionProps = {
  correctUrl: string
}

/**
 * Client component that updates the browser URL without reloading the page.
 * Used for human visitors when the URL has changed.
 */
export function UrlCorrection({ correctUrl }: UrlCorrectionProps) {
  useEffect(() => {
    window.history.replaceState(null, '', correctUrl)
  }, [correctUrl])

  return null
}
